import SearchScreen from './SearchScreen';

export default SearchScreen;
